import { FormattedMessage } from 'react-intl';
import { Value } from 'react-select';

import {
    DEBIT_CARD_TYPE,
    MANUAL_BANK_TRANSFER_TYPE,
    TRUELAYER_REPAYMENT_TYPE
} from '../EarlyRepaymentHelper';
import { PaymentMethodLogo } from './PaymentMethodLogo';
import styles from './PaymentMethodValue.module.css';
import messages from './SelectPaymentMethod.messages';

export class PaymentMethodValue extends Value {
    renderLabel() {
        const {
            value: { label, type }
        } = this.props;

        switch (type) {
            case DEBIT_CARD_TYPE:
                return (
                    <FormattedMessage
                        {...messages.cardOption}
                        values={{ cardLastDigits: label }}
                    />
                );
            case 'BANK_ACCOUNT':
                return (
                    <FormattedMessage
                        {...messages.bankAccountOption}
                        values={{ accountNumber: label }}
                    />
                );
            case MANUAL_BANK_TRANSFER_TYPE:
                return <FormattedMessage {...messages.manualPayment} />;
            case TRUELAYER_REPAYMENT_TYPE:
                return <FormattedMessage {...messages.truelayerRepayment} />;
            default:
                return <>{label}</>;
        }
    }

    renderIcon() {
        const {
            value: { issuer, type }
        } = this.props;

        const logoStyle = styles.icon;

        return (
            <PaymentMethodLogo
                type={type}
                issuer={issuer}
                logoStyle={logoStyle}
            />
        );
    }

    render() {
        const icon = this.renderIcon();

        return (
            <div
                data-testid="selected-value"
                className={styles.PaymentMethodValue}
            >
                {icon}
                {super.render()}
            </div>
        );
    }
}
